module.exports = __webpack_public_path__ + "img/Kb.baadc000.png";